module.exports = __webpack_public_path__ + "static/media/设备状态.e80bb7b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/img/diagnostic/设备状态.png
// module id = 5065
// module chunks = 0